import type { CountyAdapter, ParsedDocument } from "../types";

const parse = (text: string): ParsedDocument[] => {
  const lines = text
    .split("\n")
    .map((l) => l.trim())
    .filter((l) => l.length > 0);
  const out: ParsedDocument[] = [];

  for (let i = 0; i + 5 < lines.length; i += 6) {
    const documentNumber = lines[i];
    const docTypeRaw = lines[i + 1];
    const filingDateTime = lines[i + 2];
    const grantor = lines[i + 3];
    const grantee = lines[i + 4];
    const legal = lines[i + 5];

    const dm = filingDateTime.match(/(\d{1,2})\/(\d{1,2})\/(\d{4})/);
    const filingDate = dm
      ? `${dm[3]}-${dm[1].padStart(2, "0")}-${dm[2].padStart(2, "0")}`
      : new Date().toISOString().split("T")[0];

    out.push({
      documentNumber,
      documentType: docTypeRaw === "LC" ? "LAND CONTRACT" : docTypeRaw,
      filingDate,
      grantors: [grantor],
      grantees: [grantee],
      legalDescription:
        legal === "Multiple Legals: See Record" ? undefined : legal,
    });
  }
  return out;
};

export const medinaAdapter: CountyAdapter = {
  countyId: "medina",
  countyLabel: "Medina County, OH - Land Contract Parser",
  description:
    "Paste Medina County search results. Each record is 6 lines: Document #, Type, Filing Date/Time, Grantor, Grantee, Legal Description.",
  placeholder: `Paste Medina County records here...

Example (6 lines per record):
2024000012345
LC
12/31/2024 10:19:01 AM
SMITH JOHN
DOE JANE
LOT 5 PHEASANT RUN`,
  detectionReasons: ["Medina County OH", "Land Contract"],
  confidenceScore: 95,
  filterRules: [
    "6 lines per record",
    "Family/bank/business filters applied",
  ],
  parse,
};
